export interface Movie {
  id: number;
  title: string;
  category: 'movie' | 'tv' | 'variety' | 'anime';
  subCategory: string;
  year: number;
  rating: number;
  coverImage: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  updateInfo: string;
  tags: string[];
  featured: boolean;
  hot: boolean;
  rank: number | null;
}

export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-movie-2-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-rocket-line' },
];

export const subCategories: Record<string, { slug: string; name: string }[]> = {
  movie: [
    { slug: 'action', name: '动作片' },
    { slug: 'comedy', name: '喜剧片' },
    { slug: 'romance', name: '爱情片' },
    { slug: 'scifi', name: '科幻片' },
    { slug: 'horror', name: '恐怖片' },
    { slug: 'drama', name: '剧情片' },
  ],
  tv: [
    { slug: 'domestic', name: '国产剧' },
    { slug: 'hk', name: '港剧' },
    { slug: 'korean', name: '韩剧' },
    { slug: 'american', name: '美剧' },
    { slug: 'japanese', name: '日剧' },
  ],
  variety: [
    { slug: 'reality', name: '真人秀' },
    { slug: 'talkshow', name: '脱口秀' },
    { slug: 'music', name: '音乐综艺' },
  ],
  anime: [
    { slug: 'domestic', name: '国产动漫' },
    { slug: 'japanese', name: '日本动漫' },
    { slug: 'western', name: '欧美动漫' },
  ],
};

export const movies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'movie',
    subCategory: 'scifi',
    year: 2027,
    rating: 9.2,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20futuristic%20Chinese%20sci-fi%20movie%20poster%20with%20astronauts%20in%20space%20suits%20standing%20before%20a%20giant%20planet%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20deep%20space%20blue%20contrast%2C%20movie%20poster%20style%20with%20Chinese%20text%20space%2C%20epic%20scale%20with%20stars%20and%20nebula%20background&width=800&height=1120&seq=movie-cover-01&orientation=portrait',
    description: '太阳急速老化，持续膨胀。为了应对这场灭顶之灾，人类决定启动"流浪地球"计划，带着地球去远方寻找新的家园。在这条长达2500年的漫长旅途中，人类将面临无数前所未有的挑战与危机，而希望，是比钻石还要珍贵的东西。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '赵今麦'],
    region: '中国大陆',
    duration: '173分钟',
    updateInfo: '2026-08-01更新至超清完整版',
    tags: ['科幻', '灾难', '冒险', '高评分'],
    featured: true,
    hot: true,
    rank: 1,
  },
  {
    id: 2,
    title: '封神第二部',
    category: 'movie',
    subCategory: 'action',
    year: 2025,
    rating: 8.8,
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20fantasy%20movie%20poster%2C%20warriors%20in%20ancient%20Chinese%20armor%20riding%20mythical%20beasts%2C%20dramatic%20battle%20scene%20with%20epic%20scale%2C%20golden%20and%20crimson%20color%20scheme%2C%20cinematic%20movie%20poster%20style%2C%20majestic%20ancient%20Chinese%20palace%20background&width=800&height=1120&seq=movie-cover-02&orientation=portrait',
    description: '大商末年，纣王暴虐无道，天下生灵涂炭。姜子牙携封神榜下山，辅佐西岐武王伐纣。一场人、仙、妖三界的大战就此拉开序幕，神话传说中的英雄们将在这场浩劫中书写自己的传奇。',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适', '陈坤'],
    region: '中国大陆',
    duration: '148分钟',
    updateInfo: '2026-07-28更新至超清完整版',
    tags: ['神话', '奇幻', '动作', '史诗'],
    featured: true,
    hot: true,
    rank: 2,
  },
  {
    id: 3,
    title: '繁花',
    category: 'tv',
    subCategory: 'domestic',
    year: 2024,
    rating: 9.0,
    coverImage: 'https://readdy.ai/api/search-image?query=Retro%201990s%20Shanghai%20drama%20series%20poster%2C%20elegant%20Chinese%20man%20in%20vintage%20suit%20walking%20on%20busy%20Shanghai%20street%20at%20night%2C%20neon%20lights%20and%20old%20shanghai%20architecture%2C%20cinematic%20moody%20lighting%2C%20nostalgic%20atmosphere%2C%20golden%20and%20dark%20tones&width=800&height=1120&seq=movie-cover-03&orientation=portrait',
    description: '九十年代的上海，处处是机遇与挑战。阿宝凭借自己的智慧和勇气，在商海中沉浮，从默默无闻到成为黄河路上叱咤风云的传奇人物。在这座不夜城里，每个人都在寻找属于自己的繁华。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    region: '中国大陆',
    duration: '30集',
    updateInfo: '全30集已完结',
    tags: ['剧情', '商战', '年代', '高分'],
    featured: true,
    hot: false,
    rank: 3,
  },
  {
    id: 4,
    title: '哪吒之魔童闹海',
    category: 'anime',
    subCategory: 'domestic',
    year: 2025,
    rating: 9.1,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20animated%20movie%20poster%20featuring%20a%20young%20mythological%20warrior%20boy%20with%20flaming%20hair%20riding%20a%20fire%20dragon%20above%20ancient%20Chinese%20city%2C%20vibrant%20red%20and%20orange%20color%20palette%2C%20dynamic%20action%20pose%2C%20watercolor%20ink%20Chinese%20painting%20style%20blended%20with%203D%20animation%2C%20epic%20cinematic%20lighting&width=800&height=1120&seq=movie-cover-04&orientation=portrait',
    description: '天劫之后，哪吒和敖丙虽然保住了灵魂，但肉身即将消散。太乙真人打算用七色宝莲为二人重塑肉身，然而在这个过程中却遭遇了重重困难。哪吒的命运将走向何方？',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨'],
    region: '中国大陆',
    duration: '144分钟',
    updateInfo: '2026-06-15更新至超清完整版',
    tags: ['动画', '神话', '喜剧', '高评分'],
    featured: true,
    hot: true,
    rank: 4,
  },
  {
    id: 5,
    title: '狂飙',
    category: 'tv',
    subCategory: 'domestic',
    year: 2023,
    rating: 9.3,
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20Chinese%20crime%20drama%20TV%20series%20poster%2C%20two%20intense%20male%20characters%20facing%20each%20other%2C%20one%20in%20police%20uniform%20and%20one%20in%20dark%20suit%2C%20dramatic%20split%20lighting%2C%20rainy%20city%20street%20background%2C%20noir%20cinematic%20style%2C%20high%20contrast%20black%20and%20warm%20tone&width=800&height=1120&seq=movie-cover-05&orientation=portrait',
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击。在长达二十年的时间里，全国政法队伍教育整顿工作开展，安欣协同专案组彻查强盛集团犯罪团伙及其背后的保护伞，终于拨云见日。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    region: '中国大陆',
    duration: '39集',
    updateInfo: '全39集已完结',
    tags: ['犯罪', '剧情', '扫黑', '神作'],
    featured: false,
    hot: true,
    rank: 5,
  },
  {
    id: 6,
    title: '奔跑吧·第12季',
    category: 'variety',
    subCategory: 'reality',
    year: 2024,
    rating: 7.8,
    coverImage: 'https://readdy.ai/api/search-image?query=Bright%20and%20colorful%20Chinese%20variety%20show%20poster%2C%20group%20of%20diverse%20Chinese%20celebrities%20running%20and%20laughing%20on%20a%20sunny%20outdoor%20location%2C%20energetic%20dynamic%20pose%2C%20vibrant%20yellow%20and%20orange%20color%20scheme%2C%20game%20show%20aesthetic%2C%20joyful%20and%20playful%20atmosphere&width=800&height=1120&seq=movie-cover-06&orientation=portrait',
    description: '《奔跑吧》第十二季全新出发！兄弟团成员再次集结，踏上全新的冒险之旅。本季将带领观众走遍祖国大好河山，在欢笑与挑战中传递正能量。',
    director: '姚译添',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深', '范丞丞'],
    region: '中国大陆',
    duration: '12期',
    updateInfo: '2026-07-20更新至第8期',
    tags: ['真人秀', '户外', '搞笑', '竞技'],
    featured: false,
    hot: false,
    rank: null,
  },
  {
    id: 7,
    title: '鬼灭之刃·无限列车篇',
    category: 'anime',
    subCategory: 'japanese',
    year: 2024,
    rating: 9.0,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20with%20a%20young%20demon%20slayer%20holding%20a%20katana%20on%20a%20moving%20train%2C%20flame%20effects%20surrounding%20him%2C%20intense%20battle%20ready%20pose%2C%20dark%20night%20with%20fire%20sparks%2C%20anime%20art%20style%20with%20dynamic%20composition%2C%20warm%20orange%20and%20deep%20blue%20contrast&width=800&height=1120&seq=movie-cover-07&orientation=portrait',
    description: '灶门炭治郎一行人与炎柱炼狱杏寿郎汇合，登上无限列车执行任务。然而这辆列车早已被鬼所控制，等待他们的是前所未有的生死考验。',
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮', '日野聪'],
    region: '日本',
    duration: '117分钟',
    updateInfo: '2026-05-10更新至超清完整版',
    tags: ['热血', '战斗', '奇幻', '日漫'],
    featured: false,
    hot: true,
    rank: 6,
  },
  {
    id: 8,
    title: '消失的她',
    category: 'movie',
    subCategory: 'drama',
    year: 2023,
    rating: 8.5,
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20Chinese%20suspense%20movie%20poster%2C%20a%20beautiful%20woman%20looking%20back%20over%20her%20shoulder%20in%20a%20dimly%20lit%20room%2C%20half%20of%20her%20face%20in%20shadow%2C%20deep%20sea%20blue%20and%20crimson%20color%20palette%2C%20psychological%20thriller%20atmosphere%2C%20cinematic%20noir%20style%2C%20mysterious%20and%20enigmatic%20mood&width=800&height=1120&seq=movie-cover-08&orientation=portrait',
    description: '何非的妻子李木子在海外旅行中离奇失踪，在他报案多日无果后，一个陌生女人突然出现并声称自己就是他的妻子。随着事情的不断深入，一个巨大的阴谋逐渐浮出水面。',
    director: '陈思诚',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    region: '中国大陆',
    duration: '122分钟',
    updateInfo: '2026-04-20更新至超清完整版',
    tags: ['悬疑', '犯罪', '反转', '口碑'],
    featured: false,
    hot: false,
    rank: 7,
  },
  {
    id: 9,
    title: '与凤行',
    category: 'tv',
    subCategory: 'domestic',
    year: 2024,
    rating: 8.6,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%2C%20a%20beautiful%20couple%20in%20flowing%20ancient%20Chinese%20robes%20with%20long%20sleeves%20standing%20among%20clouds%20and%20peach%20blossoms%2C%20soft%20ethereal%20lighting%2C%20pink%20and%20gold%20color%20palette%2C%20xianxia%20aesthetic%2C%20romantic%20and%20dreamy%20atmosphere&width=800&height=1120&seq=movie-cover-09&orientation=portrait',
    description: '碧苍王沈璃在与天界的斗争中陨落，化为原形坠落人间。被凡人行止捡到后，两人在朝夕相处中暗生情愫。然而当沈璃恢复记忆，她必须在爱情与责任之间做出选择。',
    director: '邓科',
    actors: ['赵丽颖', '林更新', '辛云来', '何与'],
    region: '中国大陆',
    duration: '39集',
    updateInfo: '全39集已完结',
    tags: ['仙侠', '爱情', '古装', '热门'],
    featured: true,
    hot: false,
    rank: 8,
  },
  {
    id: 10,
    title: '人生大事',
    category: 'movie',
    subCategory: 'drama',
    year: 2022,
    rating: 8.9,
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20Chinese%20family%20drama%20movie%20poster%2C%20a%20middle-aged%20man%20holding%20hands%20with%20a%20little%20girl%20walking%20down%20a%20narrow%20alley%20in%20old%20Chinese%20town%2C%20warm%20sunset%20light%2C%20touching%20and%20heartfelt%20atmosphere%2C%20golden%20hour%20lighting%2C%20slice%20of%20life%20cinematic%20style&width=800&height=1120&seq=movie-cover-10&orientation=portrait',
    description: '殡葬师莫三妹在一场出殡中遇到了孤儿武小文，小文的出现意外地改变了莫三妹对职业和生活的态度。两个看似毫不相干的灵魂，在荒谬的相遇中温暖了彼此。',
    director: '刘江江',
    actors: ['朱一龙', '杨恩又', '王戈', '刘陆'],
    region: '中国大陆',
    duration: '112分钟',
    updateInfo: '2026-03-15更新至超清完整版',
    tags: ['剧情', '家庭', '治愈', '口碑'],
    featured: false,
    hot: false,
    rank: 9,
  },
  {
    id: 11,
    title: '唐朝诡事录之西行',
    category: 'tv',
    subCategory: 'domestic',
    year: 2025,
    rating: 8.7,
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20detective%20drama%20poster%2C%20two%20Tang%20dynasty%20officials%20in%20traditional%20robes%20investigating%20in%20a%20foggy%20ancient%20street%20at%20night%20with%20lanterns%2C%20dark%20and%20mysterious%20atmosphere%2C%20ink%20wash%20painting%20style%20elements%2C%20suspense%20and%20intrigue&width=800&height=1120&seq=movie-cover-11&orientation=portrait',
    description: '大唐盛世之下，诡异案件频发。苏无名与卢凌风再度联手，踏上西域之路，揭开一桩桩离奇案件背后的真相。从长安到西域，一路上危机四伏。',
    director: '柏杉',
    actors: ['杨旭文', '杨志刚', '郜思雯', '陈创'],
    region: '中国大陆',
    duration: '36集',
    updateInfo: '2026-07-25更新至第24集',
    tags: ['古装', '悬疑', '探案', '唐朝'],
    featured: false,
    hot: true,
    rank: 10,
  },
  {
    id: 12,
    title: '间谍过家家',
    category: 'anime',
    subCategory: 'japanese',
    year: 2024,
    rating: 8.8,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20spy%20family%20anime%20poster%2C%20a%20stylish%20family%20of%20three%20posing%20together%2C%20father%20in%20suit%20mother%20in%20elegant%20dress%20and%20cute%20little%20girl%20with%20pink%20hair%2C%20retro%20European%20city%20background%2C%20warm%20and%20playful%20color%20palette%2C%20spy%20theme%20elements%20subtle%20in%20composition&width=800&height=1120&seq=movie-cover-12&orientation=portrait',
    description: '为了执行秘密任务，顶尖间谍"黄昏"临时组建了一个家庭。然而他不知道的是，收养的女儿是超能力者，假扮的妻子是职业杀手。这个互相隐瞒身份的家庭，在日常中上演着爆笑又温馨的故事。',
    director: '古桥一浩',
    actors: ['江口拓也', '种崎敦美', '早见沙织'],
    region: '日本',
    duration: '25集',
    updateInfo: '2026-06-30更新至第18集',
    tags: ['搞笑', '日常', '间谍', '治愈'],
    featured: false,
    hot: true,
    rank: null,
  },
  {
    id: 13,
    title: '满江红',
    category: 'movie',
    subCategory: 'drama',
    year: 2023,
    rating: 8.3,
    coverImage: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20movie%20poster%20set%20in%20Song%20dynasty%2C%20group%20of%20soldiers%20and%20officials%20in%20ancient%20Chinese%20military%20uniforms%20marching%20through%20narrow%20ancient%20alleyways%2C%20dark%20red%20and%20black%20color%20scheme%2C%20tense%20and%20dramatic%20atmosphere%2C%20epic%20historical%20cinematic%20style&width=800&height=1120&seq=movie-cover-13&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领被裹挟进这场巨大的阴谋之中。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    region: '中国大陆',
    duration: '159分钟',
    updateInfo: '2026-02-10更新至超清完整版',
    tags: ['历史', '悬疑', '喜剧', '剧情'],
    featured: false,
    hot: false,
    rank: null,
  },
  {
    id: 14,
    title: '向往的生活·第8季',
    category: 'variety',
    subCategory: 'reality',
    year: 2024,
    rating: 8.1,
    coverImage: 'https://readdy.ai/api/search-image?query=Peaceful%20Chinese%20variety%20show%20poster%2C%20group%20of%20Chinese%20celebrities%20sitting%20around%20a%20wooden%20table%20in%20a%20beautiful%20countryside%20courtyard%2C%20surrounded%20by%20green%20fields%20and%20mountains%2C%20warm%20sunlight%2C%20rustic%20and%20cozy%20atmosphere%2C%20slow%20life%20aesthetic&width=800&height=1120&seq=movie-cover-14&orientation=portrait',
    description: '回归田园，享受慢生活。蘑菇屋的家人们再次相聚，在山水之间种菜做饭，招待远道而来的朋友。远离城市的喧嚣，寻找内心真正的平静。',
    director: '王征宇',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅', '张子枫'],
    region: '中国大陆',
    duration: '14期',
    updateInfo: '2026-07-10更新至第10期',
    tags: ['慢综艺', '生活', '美食', '治愈'],
    featured: false,
    hot: false,
    rank: null,
  },
  {
    id: 15,
    title: '铃芽之旅',
    category: 'anime',
    subCategory: 'japanese',
    year: 2023,
    rating: 8.6,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20anime%20movie%20poster%2C%20a%20young%20girl%20running%20through%20a%20mystical%20doorway%20in%20an%20abandoned%20landscape%2C%20butterflies%20and%20light%20particles%20floating%20around%2C%20soft%20pastel%20blue%20and%20pink%20color%20palette%2C%20dreamy%20and%20surreal%20atmosphere%2C%20Makoto%20Shinkai%20style%20with%20intricate%20sky%20details&width=800&height=1120&seq=movie-cover-15&orientation=portrait',
    description: '17岁的少女铃芽遇见了为了寻找"门"而踏上旅途的青年。追随着青年的脚步，铃芽来到了一片废墟，在那里有一扇古老的门，仿佛是坍塌中留存下来的唯一遗迹。铃芽仿佛被什么吸引一般，将手伸向了那扇门。',
    director: '新海诚',
    actors: ['原菜乃华', '松村北斗', '深津绘里'],
    region: '日本',
    duration: '122分钟',
    updateInfo: '2026-01-25更新至超清完整版',
    tags: ['奇幻', '冒险', '爱情', '新海诚'],
    featured: false,
    hot: false,
    rank: null,
  },
  {
    id: 16,
    title: '无名',
    category: 'movie',
    subCategory: 'drama',
    year: 2023,
    rating: 8.0,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20spy%20thriller%20movie%20poster%20set%20in%201940s%20Shanghai%2C%20a%20mysterious%20man%20in%20vintage%20suit%20and%20hat%20standing%20in%20foggy%20Shanghai%20alley%2C%20art%20deco%20buildings%20in%20background%2C%20black%20and%20white%20with%20subtle%20warm%20tone%2C%20noir%20cinematic%20style%2C%20wartime%20espionage%20atmosphere&width=800&height=1120&seq=movie-cover-16&orientation=portrait',
    description: '1937年至1945年抗日战争期间，一群无名英雄在危机四伏的上海滩，潜伏于黑暗之中，用自己的方式为国家和民族默默付出。',
    director: '程耳',
    actors: ['梁朝伟', '王一博', '周迅', '黄磊'],
    region: '中国大陆',
    duration: '128分钟',
    updateInfo: '2026-01-10更新至超清完整版',
    tags: ['谍战', '历史', '悬疑', '动作'],
    featured: false,
    hot: false,
    rank: null,
  },
  {
    id: 17,
    title: '大奉打更人',
    category: 'tv',
    subCategory: 'domestic',
    year: 2025,
    rating: 8.4,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20detective%20drama%20poster%2C%20a%20young%20handsome%20official%20in%20ancient%20Chinese%20robe%20holding%20a%20sword%20with%20mystical%20energy%2C%20ancient%20city%20at%20night%20with%20lanterns%2C%20fantasy%20elements%20with%20magical%20particles%2C%20dark%20blue%20and%20gold%20color%20palette&width=800&height=1120&seq=movie-cover-17&orientation=portrait',
    description: '现代打工人许七安穿越到大奉王朝成为一名打更人，利用现代知识和推理能力，在这个妖魔横行、诡案频发的世界里屡破奇案，一步步走向权力巅峰。',
    director: '邓科',
    actors: ['王鹤棣', '田曦薇', '刘奕君', '晏紫东'],
    region: '中国大陆',
    duration: '40集',
    updateInfo: '2026-07-15更新至第28集',
    tags: ['穿越', '古装', '探案', '修仙'],
    featured: false,
    hot: true,
    rank: null,
  },
  {
    id: 18,
    title: '中国说唱巅峰对决',
    category: 'variety',
    subCategory: 'music',
    year: 2024,
    rating: 7.9,
    coverImage: 'https://readdy.ai/api/search-image?query=Cool%20Chinese%20hip-hop%20music%20competition%20show%20poster%2C%20rappers%20on%20stage%20with%20microphones%20under%20dramatic%20stage%20lighting%2C%20urban%20and%20street%20style%2C%20bold%20red%20and%20black%20color%20scheme%2C%20energetic%20and%20dynamic%20composition%2C%20music%20festival%20vibe&width=800&height=1120&seq=movie-cover-18&orientation=portrait',
    description: '华语说唱顶级赛事再度来袭！全国最顶尖的说唱歌手齐聚一堂，用音乐对话，用说唱较量。谁能站上华语说唱之巅？',
    director: '左近',
    actors: ['热狗', 'GAI', '艾热', '杨和苏'],
    region: '中国大陆',
    duration: '12期',
    updateInfo: '2026-07-05更新至第6期',
    tags: ['音乐', '说唱', '竞技', '嘻哈'],
    featured: false,
    hot: false,
    rank: null,
  },
  {
    id: 19,
    title: '你想活出怎样的人生',
    category: 'anime',
    subCategory: 'japanese',
    year: 2024,
    rating: 8.9,
    coverImage: 'https://readdy.ai/api/search-image?query=Studio%20Ghibli%20style%20Japanese%20anime%20movie%20poster%2C%20a%20young%20boy%20standing%20before%20a%20mysterious%20tower%20in%20a%20dreamlike%20landscape%2C%20herons%20flying%20overhead%2C%20soft%20watercolor%20art%20style%2C%20warm%20nostalgic%20color%20palette%2C%20surreal%20and%20philosophical%20atmosphere%2C%20hand-drawn%20animation%20aesthetic&width=800&height=1120&seq=movie-cover-19&orientation=portrait',
    description: '少年牧真人在母亲去世后，随父亲与继母组成新家庭。然而一场意外让他跟随一只会说话的苍鹭闯入了一座废弃的神秘塔楼，进入了生与死的奇幻世界。',
    director: '宫崎骏',
    actors: ['山时聪真', '菅田将晖', '柴崎幸', '木村拓哉'],
    region: '日本',
    duration: '124分钟',
    updateInfo: '2026-01-15更新至超清完整版',
    tags: ['奇幻', '冒险', '成长', '宫崎骏'],
    featured: false,
    hot: false,
    rank: null,
  },
  {
    id: 20,
    title: '三大队',
    category: 'movie',
    subCategory: 'drama',
    year: 2023,
    rating: 8.7,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20movie%20poster%2C%20three%20police%20officers%20in%20plain%20clothes%20walking%20determinedly%20through%20a%20dark%20urban%20street%2C%20rainy%20night%20atmosphere%2C%20gritty%20realistic%20style%2C%20moody%20blue-gray%20color%20palette%2C%20suspenseful%20and%20tense%20cinematic%20composition&width=800&height=1120&seq=movie-cover-20&orientation=portrait',
    description: '刑侦大队队长程兵带领三大队在办理一起恶性案件的过程中导致嫌疑人意外死亡，被判入狱。出狱后，他以普通人身份继续追踪在逃嫌犯，历时十二年终于将罪犯绳之以法。',
    director: '戴墨',
    actors: ['张译', '李晨', '魏晨', '曹炳琨'],
    region: '中国大陆',
    duration: '133分钟',
    updateInfo: '2025-12-20更新至超清完整版',
    tags: ['犯罪', '剧情', '警匪', '真实改编'],
    featured: false,
    hot: false,
    rank: null,
  },
  {
    id: 21,
    title: '梦华录',
    category: 'tv',
    subCategory: 'domestic',
    year: 2022,
    rating: 8.5,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20historical%20romance%20drama%20poster%2C%20elegant%20woman%20in%20Song%20dynasty%20silk%20dress%20serving%20tea%20in%20a%20classical%20Chinese%20garden%20pavilion%2C%20soft%20natural%20light%2C%20pink%20cherry%20blossoms%2C%20traditional%20Chinese%20aesthetic%2C%20delicate%20and%20graceful%20composition&width=800&height=1120&seq=movie-cover-21&orientation=portrait',
    description: '赵盼儿本为杭州一茶坊老板娘，因未婚夫高中探花后另娶他人，她上京讨公道。途中救下被骗婚的好姐妹宋引章，又遇到婚姻不幸的孙三娘，三姐妹携手在东京城闯出一片天地。',
    director: '杨阳',
    actors: ['刘亦菲', '陈晓', '柳岩', '林允'],
    region: '中国大陆',
    duration: '40集',
    updateInfo: '全40集已完结',
    tags: ['古装', '爱情', '女性', '励志'],
    featured: false,
    hot: false,
    rank: null,
  },
  {
    id: 22,
    title: '极限挑战·第10季',
    category: 'variety',
    subCategory: 'reality',
    year: 2024,
    rating: 7.5,
    coverImage: 'https://readdy.ai/api/search-image?query=Exciting%20Chinese%20variety%20show%20poster%2C%20group%20of%20male%20celebrities%20running%20through%20city%20streets%20in%20colorful%20outfits%2C%20action-packed%20and%20funny%20expressions%2C%20bright%20urban%20background%2C%20vibrant%20yellow%20and%20red%20color%20scheme%2C%20competitive%20game%20show%20energy&width=800&height=1120&seq=movie-cover-22&orientation=portrait',
    description: '极限挑战第十季热血回归！男人帮新老成员继续斗智斗勇，在全新的挑战任务中展现团队精神和极限智慧。',
    director: '施嘉宁',
    actors: ['黄晓明', '黄景瑜', '龚俊', '黄明昊', '大张伟'],
    region: '中国大陆',
    duration: '12期',
    updateInfo: '2026-06-20更新至第5期',
    tags: ['户外', '竞技', '搞笑', '真人秀'],
    featured: false,
    hot: false,
    rank: null,
  },
  {
    id: 23,
    title: '你的名字',
    category: 'anime',
    subCategory: 'japanese',
    year: 2016,
    rating: 9.2,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20anime%20movie%20poster%2C%20a%20boy%20and%20girl%20reaching%20toward%20each%20other%20under%20a%20dramatic%20twilight%20sky%20with%20a%20falling%20comet%2C%20stunning%20cloud%20and%20sky%20details%2C%20warm%20orange%20and%20soft%20blue%20gradient%2C%20romantic%20and%20breathtaking%20Makoto%20Shinkai%20style&width=800&height=1120&seq=movie-cover-23&orientation=portrait',
    description: '生活在乡下的三叶和东京的高中生泷，在某天醒来后发现自己与对方交换了身体。两人在彼此的生活中留下了深刻的印记，一段跨越时空的爱情故事由此展开。',
    director: '新海诚',
    actors: ['神木隆之介', '上白石萌音', '长泽雅美'],
    region: '日本',
    duration: '106分钟',
    updateInfo: '经典重温，超清修复版',
    tags: ['爱情', '奇幻', '治愈', '经典'],
    featured: false,
    hot: false,
    rank: null,
  },
  {
    id: 24,
    title: '第二十条',
    category: 'movie',
    subCategory: 'drama',
    year: 2024,
    rating: 8.2,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%2C%20a%20serious%20prosecutor%20in%20formal%20uniform%20standing%20in%20a%20courtroom%2C%20dramatic%20lighting%20from%20above%2C%20solemn%20and%20authoritative%20atmosphere%2C%20warm%20golden%20and%20deep%20brown%20tones%2C%20justice%20and%20law%20theme&width=800&height=1120&seq=movie-cover-24&orientation=portrait',
    description: '挂职检察官韩明人到中年，本想努力进入市院工作，却卷入了一桩分歧巨大的案件。面对各方压力，他必须在法与情之间做出艰难的抉择。',
    director: '张艺谋',
    actors: ['雷佳音', '马丽', '赵丽颖', '高叶'],
    region: '中国大陆',
    duration: '141分钟',
    updateInfo: '2025-11-15更新至超清完整版',
    tags: ['剧情', '法律', '社会', '张艺谋'],
    featured: false,
    hot: false,
    rank: null,
  },
];

export const getFeaturedMovies = () => movies.filter(m => m.featured);
export const getHotMovies = () => movies.filter(m => m.hot);
export const getTopRanked = () => movies.filter(m => m.rank !== null).sort((a, b) => (a.rank || 99) - (b.rank || 99));
export const getMoviesByCategory = (cat: string) => movies.filter(m => m.category === cat);
export const getMovieById = (id: number) => movies.find(m => m.id === id);
export const getRelatedMovies = (movie: Movie, count: number = 6) => {
  return movies.filter(m => m.id !== movie.id && m.category === movie.category).slice(0, count);
};

export const siteInfo = {
  name: '51影院',
  description: '51影院汇聚6080影院、小a影院等免费高清影视资源，在线观看超清画质，免广告不缓冲，流畅体验。',
  keywords: '6080影院,小a影院,免费观看,在线观看,免广告,超清画质,8090影院,4480影院,51影院,高清,不缓冲,免费',
  url: 'https://qxgzxa.cn',
  email: 'contact@51cinema.com',
  phone: '400-888-5151',
  address: '北京市朝阳区望京SOHO T1 18层',
  year: 2024,
};

export const faqData = [
  {
    question: '51影院需要注册会员才能观看吗？',
    answer: '不需要！51影院完全免费，无需注册登录即可在线观看所有影视内容。我们致力于为影迷提供最便捷的观影体验。',
  },
  {
    question: '51影院的视频画质怎么样？',
    answer: '我们提供超清画质（1080P及以上）的影视资源，确保您享受最佳的观影效果。所有视频资源均经过精心筛选和优化，画质清晰流畅。',
  },
  {
    question: '观看视频会有广告吗？',
    answer: '不会！51影院承诺免广告观影体验，您可以直接观看正片内容，不会被任何广告打扰。',
  },
  {
    question: '51影院支持哪些设备观看？',
    answer: '51影院支持电脑、平板、手机等多种设备在线观看，您可以在任何设备上享受流畅的观影体验。',
  },
  {
    question: '51影院的资源更新速度快吗？',
    answer: '我们与6080影院、8090影院、4480影院等多个优质资源站保持同步更新，热门影视资源通常在上线后24小时内即可在51影院观看。',
  },
];

export const reviewData = [
  { name: '影迷小王', rating: 5, content: '用了51影院好几个月了，真的免广告，画质也超清晰，比那些乱七八糟的网站好太多了！强烈推荐！', date: '2026-07-28' },
  { name: '追剧达人', rating: 5, content: '资源更新速度很快，6080影院和小a影院的资源这里都有，一个网站就够了，不用到处找了。', date: '2026-07-25' },
  { name: '电影爱好者', rating: 4, content: '画质确实不错，播放也很流畅，基本没有卡顿。分类也很清晰，找片子很方便。', date: '2026-07-20' },
  { name: '周末宅家', rating: 5, content: '周末在家用51影院追了一整天的剧，完全不卡！8090影院的资源这里也能看，太方便了。', date: '2026-07-18' },
  { name: '老影迷', rating: 5, content: '界面简洁干净，没有乱七八糟的弹窗和广告，观影体验非常好。4480影院的经典老片这里也有。', date: '2026-07-15' },
  { name: '学生党', rating: 4, content: '免费又高清，对我们学生来说简直太友好了！同学推荐给我的，现在全班都在用。', date: '2026-07-12' },
];